<template>
    <router-link
         :to="route"
         :class="this.class"
         >{{linkText}}</router-link>
</template>

<script>
import framework from '../../framework';
import MissingComponentAttributeError from '../../framework/errors/MissingComponentAttributeError';

/**
 *  The x-element-container component.
 *  @module components/x-link
 */


/**
 * The x-link is a basic element-container.
 */

export default {
    name: 'x-link',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataRoute: String,
        dataLinkText: String,
    },
    computed: {
        route() {
            return this.getAttribute('route', null,
                new MissingComponentAttributeError('x-link', 'route'));
        },

        linkText() {
            return this.getAttribute('linkText', 'Link Text');
        },
    },
};
</script>
<style lang="scss">
    @import
        "../../styles/settings",
        "link";
</style>



// WEBPACK FOOTER //
// source/components/x-link/x-link.vue